import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation } from "../../../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../../../core/logManager";
import { resetALL } from "../../../../../../../.globals/redux/actions";
import { NotificationManager } from "../../../../../../../components/Notifications";

const INIT_STATE = {
  open: false,
  loading: false,
  result: null,
  error: null,
  deleteEquipment: null,
  deleteEquipmentList: [],
};

const route = "modules/manage/modals/deleteManage/redux/slice";

export const manageDeleteManageEquipment = createAsyncThunk(
  "manage/deleteManageEquipment/deleteManageEquipment",
  async (payload, { rejectWithValue }) => {
    const mutations = [];
    try {
      const { id, items } = payload;
      if (id) {
        const data = await clientMutation(
          `mutation ($id: Int!){
              deleteEquipment: deleteEquipment(id: $id)
            }`,
          {
            id,
          },
          endpoints.GRAPHQL_GENERAL_V2
        );
        if (data?.deleteEquipment) return data.deleteEquipment;
        else throw "Error while deleting manage Equipment";
      }
      if (items?.length) {
        items.forEach((manage, index) =>
          mutations.push(`deleteEquipment${index}: deleteEquipment(
                  id: ${manage.id}
              )`)
        );
        const mutation = `mutation { ${mutations.join(" ")} }`;
        const data = await clientMutation(
          mutation,
          {
            id,
          },
          endpoints.GRAPHQL_GENERAL_V2
        );
        if (data?.deleteEquipment0) return data.deleteEquipment0;
        else throw "Error while deleting manage Equipments";
      }
    } catch (exc) {
      NotificationManager.error(
        "Error",
        `Error Deleting Manage Equipment`,
        3000,
        null,
        null,
        "error"
      );
      ExceptionManager(exc, route, "deleteEquipment");
      rejectWithValue(exc);
    }
  }
);

const manageDeleteManageEquipmentRedux = createSlice({
    name: "manage/deleteManageEquipment",
    initialState: INIT_STATE,
    reducers: {
      reset(state, action) {
        return action.payload
          ? { ...state, ...action.payload }
          : { ...INIT_STATE };
      },
      openModalDeleteManageEquipment(state, action) {
        state.open = true;
        state.deleteEquipment = action?.payload?.deleteEquipment;
        state.deleteEquipmentList = action?.payload?.deleteEquipmentList;
      },
    },
    extraReducers: (builder) => {
      builder.addCase(resetALL, () => INIT_STATE);
  
      //manageDeleteManageEquipment
      builder.addCase(manageDeleteManageEquipment.pending, (state) => {
        state.loading = true;
      });
      builder.addCase(manageDeleteManageEquipment.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
      builder.addCase(manageDeleteManageEquipment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    },
  });

  // Extract and export the action creators object and the reducer
export const { actions, reducer } = manageDeleteManageEquipmentRedux;

// Extract and export each action creator by name
export const { reset, openModalDeleteManageEquipment } = actions;

// Export the reducer, either as a default or named export
export default reducer;
